// extracted by mini-css-extract-plugin
export default {"section":"HhyGKWhN","title":"eNDTW2i5","requirementsBox":"rvXxSvtY","item":"pl5pxmdF","icon":"m6Be52TK","text":"s29EZ7Zo"};